/*
 * SANBY 商品レコメンデーション
 * 2026-08-28にShopify商品レコメンデーションAPI（/recommendations/products.json）への
 * 直接fetch＋JS描画として実装したが、そのAPIはメタフィールドを返さないため、カスタム
 * オプション（印面内容等）が必要な商品かどうか判定できず、カートボタンを安全に出し分け
 * られなかった。2026-09-01、Shopify公式の「レコメンド専用セクションをfetchする」方式
 * （sections/product-recommendations.liquidを/recommendations/products?section_id=...
 * 経由で取得し、返ってきたHTMLをそのまま差し込む）に置き換えた。このエンドポイントで
 * 描画されるセクションはLiquidとして実行されるため、product.metafieldsに直接アクセスでき、
 * カスタムオプションが必要な商品を正しく商品ページリンクに振り分けられる
 * （snippets/plp-card.liquid参照）。
 * このファイルの役割は2つ：
 * ①[data-recommend-target]をfetchしてHTMLを差し込む、②差し込まれたカードのカートボタン
 * （[data-add-cart]、event delegationなので後から追加されたカードにも効く）の処理。
 */
window.SANBY = window.SANBY || {};

(function (SANBY) {
  const { addItem } = SANBY.cartApi;

  const ADDED_LABEL = "追加しました ✓";
  const LOADING_HTML = `<span class="plp-cart-spinner" aria-hidden="true"></span><span class="visually-hidden">追加中...</span>`;
  const RESET_DELAY_MS = 1800;

  // ページ内の[data-recommend-target]（main-product.liquid/snippets/cart-recommendations.liquid
  // が置くプレースホルダー）をそれぞれfetchし、返ってきたHTML（0件なら空文字）を差し込む。
  // 中身が空のときは親の[data-recommend-block]（見出しごとの<section>）を隠したままにする。
  function loadRecommendationBlocks() {
    document.querySelectorAll("[data-recommend-target]").forEach((target) => {
      const url = target.dataset.recommendUrl;
      if (!url) return;
      fetch(url)
        .then((res) => (res.ok ? res.text() : ""))
        .then((html) => {
          const trimmed = html.trim();
          target.innerHTML = trimmed;
          const block = target.closest("[data-recommend-block]");
          if (block) block.hidden = trimmed === "";
        })
        .catch(() => {});
    });
  }

  // root内の[data-add-cart-variant]（値はvariant ID）をカート追加ボタンとして扱う。連打防止・
  // ローディング/追加済み表示はpage-collection.jsのカードと同じ見た目（.plp-cart-btn系）。
  // onAdded: 追加成功時に呼ぶコールバック（カートページ側で自分のカート表示を更新する用途）。
  // 属性名をdata-add-cartではなくdata-add-cart-variantにしているのは、商品ページ本体の
  // 「カートに入れる」ボタン（bare属性のdata-add-cart、page-product.js）と衝突しないため
  // （2026-09-01に実際に事故ったので分けた）。
  function bindAddToCartButtons(root, onAdded) {
    if (!root) return;
    root.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-add-cart-variant]");
      if (!btn || btn.disabled) return;
      const variantId = btn.dataset.addCartVariant;
      const originalLabel = btn.textContent;

      btn.disabled = true;
      btn.classList.add("is-loading");
      btn.innerHTML = LOADING_HTML;

      addItem({ id: variantId, quantity: 1 })
        .then(() => {
          btn.classList.remove("is-loading");
          btn.classList.add("is-added");
          btn.textContent = ADDED_LABEL;
          setTimeout(() => {
            btn.disabled = false;
            btn.classList.remove("is-added");
            btn.textContent = originalLabel;
          }, RESET_DELAY_MS);
          if (onAdded) onAdded();
        })
        .catch((err) => {
          console.error("カートへの追加に失敗しました:", err);
          btn.disabled = false;
          btn.classList.remove("is-loading");
          btn.textContent = originalLabel;
        });
    });
  }

  SANBY.recommendations = {
    loadRecommendationBlocks,
    bindAddToCartButtons,
  };
})(window.SANBY);
